import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
// eslint-disable-next-line no-unused-vars
import { collection, addDoc, getDocs, query, where, orderBy, doc, deleteDoc, updateDoc, serverTimestamp, getCountFromServer } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoAddCircleOutline, IoStatsChartOutline, IoTrashOutline, IoPencilOutline } from 'react-icons/io5';
import AIAssistantButton from '../components/Shared/AIAssistantButton';
import './SeguridadScreen.css'; // Reutilizando layout general
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';

function GestionEncuestasScreen() {
    const navigate = useNavigate();
    const { userData, currentUser } = useAuth();
    const [encuestas, setEncuestas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);

    // Form State
    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [tipo, setTipo] = useState('opcion_multiple'); // opcion_multiple, si_no, calificacion, votacion_asamblea
    const [opciones, setOpciones] = useState([{ id: 1, texto: '', votos: 0 }, { id: 2, texto: '', votos: 0 }]);
    const [fechaFin, setFechaFin] = useState('');

    // Reglas State
    const [reglaPropietarios, setReglaPropietarios] = useState(false);
    const [reglaMorosos, setReglaMorosos] = useState(true); // true = sí se permiten, false = bloqueados
    const [reglaVotosCasa, setReglaVotosCasa] = useState(1);
    const [reglaAnonima, setReglaAnonima] = useState(false);
    const [reglaResultados, setReglaResultados] = useState('despues_de_votar'); // siempre, despues_de_votar, solo_admin

    useEffect(() => {
        if (!userData?.condominioId) return;
        fetchEncuestas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData]);

    const fetchEncuestas = async () => {
        setLoading(true);
        try {
            const q = query(
                collection(db, 'encuestas'),
                where('condominioId', '==', userData.condominioId),
                orderBy('fechaInicio', 'desc')
            );
            const snapshot = await getDocs(q);
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            // También podríamos hacer un fetch de los votos totales, pero por ahora mostramos la data base.
            setEncuestas(list);
        } catch (error) {
            console.error("Error cargando encuestas", error);
        }
        setLoading(false);
    };

    const handleAddOpcion = () => {
        setOpciones([...opciones, { id: Date.now(), texto: '', votos: 0 }]);
    };

    const handleOpcionChange = (id, text) => {
        setOpciones(opciones.map(opt => opt.id === id ? { ...opt, texto: text } : opt));
    };

    const handleRemoveOpcion = (id) => {
        if (opciones.length <= 2) {
            alert("Debe haber al menos 2 opciones.");
            return;
        }
        setOpciones(opciones.filter(opt => opt.id !== id));
    };

    const handleTipoChange = (e) => {
        const val = e.target.value;
        setTipo(val);
        if (val === 'si_no') {
            setOpciones([{ id: 1, texto: 'Sí', votos: 0 }, { id: 2, texto: 'No', votos: 0 }]);
        } else if (val === 'calificacion') {
            setOpciones(Array.from({ length: 10 }, (_, i) => ({ id: i + 1, texto: `${i + 1}`, votos: 0 })));
        } else if (val === 'votacion_asamblea') {
            setReglaPropietarios(true);
            setReglaMorosos(false);
            setReglaVotosCasa(1);
            setOpciones([{ id: 1, texto: 'Opción 1', votos: 0 }, { id: 2, texto: 'Opción 2', votos: 0 }]);
        } else {
            setOpciones([{ id: 1, texto: 'Opción 1', votos: 0 }, { id: 2, texto: 'Opción 2', votos: 0 }]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación
        if (!titulo.trim()) return alert("El título es obligatorio");
        if (!fechaFin) return alert("Debes seleccionar una fecha de fin");

        const opcionesValidas = opciones.filter(o => o.texto.trim() !== '');
        if (opcionesValidas.length < 2) return alert("Debes tener al menos 2 opciones válidas");

        try {
            const nuevaEncuesta = {
                condominioId: userData.condominioId,
                creadorId: currentUser.uid,
                titulo,
                descripcion,
                tipo,
                opciones: opcionesValidas.map(o => ({ id: o.id.toString(), texto: o.texto, votos: 0 })),
                fechaInicio: serverTimestamp(),
                fechaFin: new Date(fechaFin),
                estado: 'activa',
                reglas: {
                    soloPropietarios: reglaPropietarios,
                    permiteMorosos: reglaMorosos,
                    maxVotosPorCasa: Number(reglaVotosCasa),
                    esAnonima: reglaAnonima,
                    resultadosPublicos: reglaResultados
                },
                totalVotos: 0
            };

            await addDoc(collection(db, 'encuestas'), nuevaEncuesta);
            alert("Encuesta creada existosamente");
            setShowForm(false);
            resetForm();
            fetchEncuestas();
        } catch (error) {
            console.error("Error creando encuesta", error);
            alert("Hubo un error al crear la encuesta");
        }
    };

    const resetForm = () => {
        setTitulo('');
        setDescripcion('');
        setTipo('opcion_multiple');
        setOpciones([{ id: 1, texto: '', votos: 0 }, { id: 2, texto: '', votos: 0 }]);
        setFechaFin('');
        setReglaPropietarios(false);
        setReglaMorosos(true);
        setReglaVotosCasa(1);
        setReglaAnonima(false);
        setReglaResultados('despues_de_votar');
    };

    const toggleEstado = async (encuesta) => {
        const nuevoEstado = encuesta.estado === 'activa' ? 'cerrada' : 'activa';
        try {
            await updateDoc(doc(db, 'encuestas', encuesta.id), { estado: nuevoEstado });
            fetchEncuestas();
        } catch (e) { console.error(e); }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("¿Seguro que deseas eliminar esta encuesta? Se perderán todos los votos.")) return;
        try {
            await deleteDoc(doc(db, 'encuestas', id));
            fetchEncuestas();
        } catch (e) {
            alert("Error al eliminar");
        }
    };

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/admin/encuestas" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="muro-header-stitch">
                        <div className="muro-hero-card" style={{ background: showForm ? 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)' : undefined }}>
                            <div className="muro-hero-content" style={{ display: 'flex', alignItems: 'center', gap: '15px', width: '100%', zIndex: 2, position: 'relative' }}>
                                {showForm && (
                                    <button 
                                        type="button"
                                        onClick={() => setShowForm(false)} 
                                        style={{ 
                                            background: 'rgba(255,255,255,0.2)', 
                                            backdropFilter: 'blur(5px)', 
                                            border: 'none', 
                                            borderRadius: '50%', 
                                            width: '42px', 
                                            height: '42px', 
                                            display: 'flex', 
                                            justifyContent: 'center', 
                                            alignItems: 'center', 
                                            cursor: 'pointer', 
                                            transition: 'background 0.2s', 
                                            color: 'white', 
                                            flexShrink: 0 
                                        }}
                                    >
                                        <IoArrowBack size={22} />
                                    </button>
                                )}
                                <div>
                                    <h1 style={{ color: 'white', margin: '0 0 5px', fontSize: '1.6rem', fontWeight: '800' }}>
                                        {showForm ? 'Nueva Encuesta' : 'Votaciones'}
                                    </h1>
                                    <p style={{ color: 'rgba(255, 255, 255, 0.9)', margin: 0, fontSize: '0.9rem', fontWeight: '500' }}>
                                        {showForm ? 'Configura consultas vecinales y votaciones.' : 'Gestión de Encuestas'}
                                    </p>
                                </div>
                                {!showForm && (
                                    <button
                                        className="muro-hero-action-btn"
                                        onClick={() => setShowForm(true)}
                                        style={{ marginLeft: 'auto' }}
                                    >
                                        <IoAddCircleOutline size={20} />
                                        <span>Nuevo</span>
                                    </button>
                                )}
                            </div>
                            <IoStatsChartOutline className="muro-hero-icon-decor" />
                        </div>
                    </div>

                    <div className="seguridad-container" style={{ paddingTop: '10px' }}>

            <div>
                {!showForm ? (
                    <>
                        {loading ? <p>Cargando...</p> : encuestas.length === 0 ? <p>No hay encuestas creadas.</p> : (
                            <div style={{ display: 'grid', gap: '15px' }}>
                                {encuestas.map(enc => (
                                    <div key={enc.id} style={{ backgroundColor: 'white', padding: '15px', borderRadius: '12px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <h3 style={{ margin: '0 0 5px 0', color: '#1f2937' }}>{enc.titulo}</h3>
                                            <span style={{ fontSize: '0.8rem', padding: '4px 8px', borderRadius: '12px', backgroundColor: enc.estado === 'activa' ? '#dcfce7' : '#f3f4f6', color: enc.estado === 'activa' ? '#166534' : '#6b7280', fontWeight: 'bold' }}>
                                                {enc.estado.toUpperCase()}
                                            </span>
                                        </div>
                                        <p style={{ margin: '0 0 10px 0', fontSize: '0.9rem', color: '#6b7280' }}>
                                            TIPO: {enc.tipo.replace('_', ' ').toUpperCase()} <br />
                                            {enc.totalVotos} votos registrados.
                                        </p>

                                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                            <button
                                                onClick={() => navigate(`/admin/encuestas/${enc.id}/resultados`)}
                                                className="action-btn-secondary"
                                                style={{ flex: 1, justifyContent: 'center' }}
                                            >
                                                <IoStatsChartOutline /> Resultados
                                            </button>
                                            <button
                                                onClick={() => toggleEstado(enc)}
                                                className="action-btn-primary"
                                                style={{ 
                                                    backgroundColor: enc.estado === 'activa' ? '#f59e0b' : '#10b981',
                                                    padding: '8px 15px',
                                                    fontSize: '0.9rem'
                                                }}
                                            >
                                                {enc.estado === 'activa' ? 'Cerrar' : 'Reabrir'}
                                            </button>
                                            <button
                                                onClick={() => handleDelete(enc.id)}
                                                className="glass-icon-btn danger-glass"
                                            >
                                                <IoTrashOutline size={20} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                ) : (
                    <form onSubmit={handleSubmit} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
                        <div style={{ display: 'grid', gap: '20px' }}>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                                <label style={{ fontWeight: '600', color: '#374151', marginBottom: '8px', display: 'block' }}>Título de la encuesta / Pregunta</label>
                                <input
                                    type="text"
                                    value={titulo}
                                    onChange={e => setTitulo(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '1rem' }}
                                    placeholder="Ej. Cambio de portón principal"
                                />
                            </div>

                            <div className="form-group" style={{ marginBottom: 0 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <label style={{ fontWeight: '600', color: '#374151', margin: 0 }}>Contexto o Descripción (Opcional)</label>
                                    <AIAssistantButton 
                                        textoOriginal={descripcion}
                                        onSugerenciaAceptada={(nuevoTexto) => setDescripcion(nuevoTexto)}
                                        contexto="encuestas"
                                    />
                                </div>
                                <textarea
                                    value={descripcion}
                                    onChange={e => setDescripcion(e.target.value)}
                                    rows="2"
                                    style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '1rem', resize: 'vertical' }}
                                    placeholder="Detalla los motivos o contexto de esta votación..."
                                ></textarea>
                            </div>

                            <div className="form-group" style={{ marginBottom: 0 }}>
                                <label style={{ fontWeight: '600', color: '#374151', marginBottom: '8px', display: 'block' }}>Tipo de Encuesta</label>
                                <select
                                    value={tipo}
                                    onChange={handleTipoChange}
                                    style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '1rem', backgroundColor: 'white' }}
                                >
                                    <option value="opcion_multiple">Opción Múltiple Estándar</option>
                                    <option value="si_no">Aprobación (Sí / No)</option>
                                    <option value="calificacion">Calificación (1 al 10)</option>
                                    <option value="votacion_asamblea">Votación de Asamblea (Reglas Estrictas)</option>
                                </select>
                            </div>

                            {/* Opciones Builder */}
                            {(tipo === 'opcion_multiple' || tipo === 'votacion_asamblea') && (
                                <div style={{ backgroundColor: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                    <label style={{ fontWeight: '600', color: '#374151', marginBottom: '15px', display: 'block' }}>Opciones de Respuesta</label>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        {opciones.map((opt, index) => (
                                            <div key={opt.id} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: '#64748b' }}>
                                                    {index + 1}
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder={`Escribe la opción ${index + 1}`}
                                                    value={opt.texto}
                                                    onChange={(e) => handleOpcionChange(opt.id, e.target.value)}
                                                    style={{ flex: 1, padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.95rem' }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveOpcion(opt.id)}
                                                    className="glass-icon-btn danger-glass"
                                                    title="Eliminar opción"
                                                >
                                                    <IoTrashOutline size={20} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={handleAddOpcion}
                                        className="action-btn-secondary"
                                        style={{ marginTop: '15px', width: '100%', justifyContent: 'center', borderStyle: 'dashed' }}
                                    >
                                        <IoAddCircleOutline size={20} /> Agregar Nueva Opción
                                    </button>
                                </div>
                            )}

                            <div className="form-group" style={{ marginBottom: 0 }}>
                                <label style={{ fontWeight: '600', color: '#374151', marginBottom: '8px', display: 'block' }}>Fecha y Hora Límite para Votar</label>
                                <input
                                    type="datetime-local"
                                    value={fechaFin}
                                    onChange={e => setFechaFin(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '1rem' }}
                                />
                            </div>

                            {/* REGLAS DEL JUEGO */}
                            <div style={{ backgroundColor: '#fff7ed', padding: '20px', border: '1px solid #fed7aa', borderRadius: '12px' }}>
                                <h4 style={{ margin: '0 0 15px 0', color: '#c2410c', fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    Reglas de Participación
                                </h4>

                                <div style={{ display: 'grid', gap: '15px' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: tipo === 'votacion_asamblea' ? 'not-allowed' : 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={reglaPropietarios}
                                            onChange={e => setReglaPropietarios(e.target.checked)}
                                            disabled={tipo === 'votacion_asamblea'}
                                            style={{ width: '20px', height: '20px', accentColor: '#f97316' }}
                                        />
                                        <span style={{ fontSize: '0.95rem', color: '#431407' }}>Solo Propietarios pueden votar</span>
                                    </label>

                                    <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: tipo === 'votacion_asamblea' ? 'not-allowed' : 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={reglaMorosos}
                                            onChange={e => setReglaMorosos(e.target.checked)}
                                            disabled={tipo === 'votacion_asamblea'}
                                            style={{ width: '20px', height: '20px', accentColor: '#f97316' }}
                                        />
                                        <span style={{ fontSize: '0.95rem', color: '#431407' }}>Permitir votar a residentes con adeudos</span>
                                    </label>

                                    <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={reglaAnonima}
                                            onChange={e => setReglaAnonima(e.target.checked)}
                                            style={{ width: '20px', height: '20px', accentColor: '#f97316' }}
                                        />
                                        <span style={{ fontSize: '0.95rem', color: '#431407' }}>Voto Anónimo (Ocultar identidad en resultados)</span>
                                    </label>

                                    <div style={{ borderTop: '1px solid #fed7aa', paddingTop: '15px', marginTop: '5px' }}>
                                        <label style={{ fontWeight: '600', color: '#c2410c', marginBottom: '8px', display: 'block', fontSize: '0.95rem' }}>Votos permitidos por casa (Unidad habitacional)</label>
                                        <input
                                            type="number"
                                            min="1"
                                            max="10"
                                            value={reglaVotosCasa}
                                            onChange={e => setReglaVotosCasa(e.target.value)}
                                            disabled={tipo === 'votacion_asamblea'}
                                            style={{ width: '100%', padding: '10px', border: '1px solid #fdba74', borderRadius: '8px', backgroundColor: tipo === 'votacion_asamblea' ? '#ffedd5' : 'white' }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ fontWeight: '600', color: '#c2410c', marginBottom: '8px', display: 'block', fontSize: '0.95rem' }}>¿Quién puede ver los resultados?</label>
                                        <select
                                            value={reglaResultados}
                                            onChange={e => setReglaResultados(e.target.value)}
                                            style={{ width: '100%', padding: '10px', border: '1px solid #fdba74', borderRadius: '8px', backgroundColor: 'white' }}
                                        >
                                            <option value="despues_de_votar">Residentes, después de que emitan su voto</option>
                                            <option value="siper">Residentes, en todo momento (público)</option>
                                            <option value="solo_admin">Solo Administración / Privado</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowForm(false)}
                                    className="action-btn-secondary"
                                    style={{ flex: 1, padding: '16px', justifyContent: 'center' }}
                                >
                                    CANCELAR
                                </button>
                                <button
                                    type="submit"
                                    className="action-btn-primary"
                                    style={{ flex: 1, padding: '16px', justifyContent: 'center', backgroundColor: '#8b5cf6' }}
                                >
                                    PUBLICAR ENCUESTA
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
          </div>
        </div>
        <KondoBottomNav activeRoute="" />
      </main>
    </div>
    );
}

export default GestionEncuestasScreen;
